module.exports = "<div #content class=\"app-modal-container-wrapper\">\n  <div  >\n\n    <generic-chart></generic-chart>\n\n  </div>\n\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/charts/generic-chart-modal/generic-chart-modal-container.component.html
// module id = ./src/app/admin/charts/generic-chart-modal/generic-chart-modal-container.component.html
// module chunks = main